
    import { CreateCompletionRequest } from "openai"
    import { defineComponent, PropType } from "vue"
    import InputText from "./InputText.vue"

    export const defaultGPTSettings = {
        max_tokens: 2000,
        model: "gpt-3.5-turbo-0301",
        temperature: 0.01,
        top_p: 1,
        presence_penalty: 0,
        frequency_penalty: 0.5,
    }

    export default defineComponent({
        props: {
            value: {
                type: Object as PropType<Partial<CreateCompletionRequest>>,
            },

        },
        components: {
            InputText
        },
        // emits: ['update:modelValue'], this.$emit('update:modelValue', title)
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {
            setToDefault() {
                this.$emit("update:value", defaultGPTSettings)
            },

        },
    })

    